import * as React from 'react';

import { INFLUENCER_APP_ANDROID_LINK, INFLUENCER_APP_IOS_LINK } from 'utils/mobile-app';

import './app-store-links.scss';

export const EXTERNAL_WEBSITE_LINK = 'https://www.collabary.com';
export const EXTERNAL_HELP_LINK = 'http://help.collabary.com';

const AppStoreLinks = () => (
  <div className="app-store-links">
    <a
      href={INFLUENCER_APP_IOS_LINK}
      className="app-store-links__badge"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        data-src="/static/images/badge-apple.svg"
        className="lazyload"
        alt="iOS app"
        height="42"
      />
    </a>
    <a
      href={INFLUENCER_APP_ANDROID_LINK}
      className="app-store-links__badge"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        data-src="/static/images/badge-android.png"
        className="lazyload"
        alt="Android app"
        height="42"
      />
    </a>
  </div>
);

export default AppStoreLinks;
